export default __webpack_public_path__ + "img/sabira_logo_full_white.e1ba38f6.svg";